import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepperData = ["内容入力", "入力内容確認", "機構へ提出"];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "解除年月日",
    keyword: "cacelDate",
    type: "text",
  },
  {
    title: "解除日における被共済職員数",
    keyword: "maStaffNum",
    type: "text",
  },
  {
    title: "解除同意書",
    keyword: "formList",
    type: "nodeInLine",
  },
  {
    title: "解除の理由",
    keyword: "cancelReason",
    type: "text",
  },
];

const schema = {};

export { stepperData, fakeTableList, schema };
